import { PERMISSIONS } from "../../app/utils/Permissions";

export default {
    header: {
        self: {},
        items: [],
    },
    aside: {
        self: {},
        items: [
            {
                title: "Dashboard",
                root: true,
                icon: "fas fa-tachometer-alt",
                page: "dashboard",
                bullet: "dot",
                permission: PERMISSIONS.YARD_ACTIVITIES_MAIN_DASHBOARD
            },
            {
                title: "Serviços",
                root: true,
                icon: "fas fa-tools",
                bullet: "dot",
                submenu: [
                    {
                        title: "Limpeza",
                        bullet: "dot",
                        page: "servicos/limpeza",
                        permission: PERMISSIONS.LIMPEZA_CHECKLIST_LIST
                    },
                    {
                        title: "Estacionamento",
                        bullet: "dot",
                        page: "servicos/estacionamento",
                        permission: PERMISSIONS.AGENDAMENTO_ESTACIONAMENTO_LIST
                    },
                ],
            },
            {
                title: "Programações",
                root: true,
                bullet: "dot",
                icon: "fas fa-clock",
                submenu: [
                    // {
                    //     title: "Gestão Operacional",
                    //     bullet: "dot",
                    //     page: "agendamentos/gestao",
                    //     permission:
                    // },
                    {
                        title: "Planejamento",
                        bullet: "dot",
                        page: "programacoes/calendario",
                        permission: PERMISSIONS.PATIO_CALENDARIO_LIST
                    },
                    {
                        title: "Agendamentos",
                        bullet: "dot",
                        page: "programacoes/agendamentos",
                        permission: PERMISSIONS.AGENDAMENTO_TRIAGEM_LIST
                    },
                ],
            },
            {
                title: "Parâmetros Operacionais",
                root: true,
                bullet: "dot",
                icon: "fas fa-sliders-h",
                submenu: [
                    {
                        title: "Cancelamento Automático",
                        bullet: "dot",
                        page: "parametros-operacionais/cancelamento-automatico",
                        permission: [PERMISSIONS.CONFIGURACAO_AGENDAMENTO_VIEW, PERMISSIONS.AGENDAMENTO_TRIAGEM_LIST],
                    },
                    {
                        title: "Produtos",
                        bullet: "dot",
                        page: "parametros-operacionais/produtos",
                        permission: PERMISSIONS.PATIO_PRODUTO_LIST
                    },
                    {
                        title: "Acondicionamento",
                        bullet: "dot",
                        page: "parametros-operacionais/acondicionamento",
                        permission: PERMISSIONS.PATIO_PRODUTO_ACONDICIONAMENTO_LIST
                    },
                ],
            },
            {
                title: "Faturamento",
                root: true,
                bullet: "dot",
                icon: "fas fa-chart-pie",
                submenu: [
                    {
                        title: "Empresas que Faturam",
                        bullet: "dot",
                        page: "faturamento/empresas",
                        permission: PERMISSIONS.PATIO_EMPRESA_FATURA_LIST
                    },
                ],
            },
            {
                title: "Relatórios",
                root: true,
                bullet: "dot",
                icon: "fas fa-chart-pie",
                page: "relatorio",
                permission: PERMISSIONS.YARD_ACTIVITIES_PATIO_RELATORIOS
            },
            {
                title: "Vagas Mensais",
                root: true,
                icon: "fas fa-user-shield",
                page: "usuario",
                bullet: "dot",
                submenu: [
                    {
                        title: "Clientes",
                        bullet: "dot",
                        page: "vaga-mensal",
                        permission: PERMISSIONS.VAGAS_MENSAIS_LIST
                    },
                    {
                        title: "Estacionamento",
                        bullet: "dot",
                        page: "servico/estacionamento",
                        permission: PERMISSIONS.SERVICO_ESTACIONAMENTO_LIST
                    },
                    {
                        title: "Limpeza",
                        bullet: "dot",
                        page: "servico/limpeza",
                        permission: PERMISSIONS.SERVICO_LIMPEZA_LIST
                    }
                ],
            },
            {
                title: "Cadastrar motorista",
                root: true,
                icon: "fas fa-plus",
                page: "motorista/cadastro-motorista",
                bullet: "dot",
                permission: PERMISSIONS.CAMINHONEIRO_CREATE
            },
        ],
    },
};
